<template>

    <ais-instant-search

        :search-client="searchClient"
        :index-name="indexName"
    >
        <ais-configure
            v-bind="searchParameters"
        />
        <div class="flex gap-4 flex-wrap md:flex-nowrap">
            <div class="w-full md:max-w-2xs">
                <div class="flex md:block justify-between">

                    <div class="flex space-x-2 md:space-x-4 w-1/5 md:w-full ">

                        <button
                            class="border md:border-2 border-blue-700 h-6 w-6 md:h-8 md:w-8 lg:h-10 lg:w-10 rounded flex items-center justify-center mb-4"
                            @click="dislpayType = 'grid'"
                            :class="{
                                'bg-white':dislpayType === 'list',
                                'bg-yellow-400': dislpayType === 'grid'
                            }"
                        >

                            <svg
                                class="border-blue-700 h-3 w-3 md:h-5 md:w-5 lg:h-6 lg:w-6" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect x="1" y="1" width="6" height="6" rx="2" stroke="#003957" stroke-width="2"/>
                                <rect x="13" y="1" width="6" height="6" rx="2" stroke="#003957" stroke-width="2"/>
                                <rect x="1" y="13" width="6" height="6" rx="2" stroke="#003957" stroke-width="2"/>
                                <rect x="13" y="13" width="6" height="6" rx="2" stroke="#003957" stroke-width="2"/>
                            </svg>
                        </button>

                        <button
                            class=" border md:border-2 border-blue-700  h-6 w-6 md:h-8 md:w-8 lg:h-10 lg:w-10    rounded flex items-center justify-center mb-4"
                            @click="dislpayType = 'list'"
                            :class="{
                                'bg-white':dislpayType === 'grid',
                                'bg-yellow-400': dislpayType === 'list'
                            }"
                        >
                            <svg
                                class="border-blue-700 h-3 w-3 md:h-5 md:w-5 lg:h-6 lg:w-6"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1 1H21" stroke="#003957" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M1 8H21" stroke="#003957" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M1 21H21" stroke="#003957" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M1 14H21" stroke="#003957" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                        </button>
                    </div>
                    <div class="mb-3 w-2/5">
                        <span class="mb-1 block text-base font-bold">categorie</span>
                        <ais-refinement-list
                            attribute="category"
                            :sort-by="['name:asc']"
                        >

                        </ais-refinement-list>
                    </div>
                    <div class="mb-3 w-2/5">
                        <span class="mb-1 block text-base font-bold">schrijver</span>
                        <employee-refinement :employees="employees"></employee-refinement>
                    </div>
                </div>


            </div>
            <div class="w-full flex">


                <ais-hits :class-names="classNamesHits">
                    <a
                        :href="item.page_url" slot="item" slot-scope="{ item }"
                        class="flex h-full flex-wrap content-between group shadow-card bg-blue-50 pt-12 pb-8 px-8 text-center rounded-lg duration-100 hover:shadow-cardHigh focus:shadow-cardHigh  hover:bg-blue-100 focus:bg-blue-100 hover:-mt-1 focus:-mt-1 focus:outline-none "
                    >
                        <div class="w-full text-blue-300">
                            <h3 class="font-semibold text-gray-800 text-xl mb-2">{{ item.title }}</h3>
                            <p class="text-sm text-blue-300 mb-4">
                                {{ item.introduction }}
                            </p>
                        </div>
                        <div class="w-full">

                            <div class="flex items-center justify-center space-x-4">
                                <div class="flex">
                                    <div v-for="author in item.authors" class="w-6">
                                        <div
                                            class="rounded-full w-8 h-8 mr-2 shadow border-2 border-white relative -ml-2 overflow-hidden"
                                            :style='{backgroundColor: author.color }'
                                        >
                                            <img
                                                v-if="author.image_url" :src="author.image_url"
                                                class="inset-0 absolute" :alt="author.name"
                                            />
                                            <div
                                                v-else
                                                class="absolute flex items-center justify-center font-bold inset-0 text-white"
                                            >
                                                <span>{{ author.name.substring(0, 1) }}</span></div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div class="text-xs text-blue-200 text-left">Geplaatst op
                                    </div>
                                    <div class="text-xs font-bold text-blue-200 text-left">
                                        {{ item.published_date }}
                                    </div>
                                </div>
                            </div>

                            <svg
                                class="stroke-current duration-100 group-hover:text-blue-700 group-focus:text-blue-700 text-gray-200 h-4 mx-auto mt-6"
                                viewBox="0 0 70 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    y="15"
                                    width="63"
                                    height="6"
                                    fill="#FFD705"
                                    stroke-width="0"
                                    class="opacity-0 group-hover:opacity-100 group-focus:opacity-100 duration-100"
                                />
                                <path
                                    d="M12.5 15H66L53 2"
                                    stroke-width="3"
                                />
                            </svg>

                        </div>
                    </a>

                </ais-hits>

            </div>
        </div>

    </ais-instant-search>
</template>

<script>
import algoliasearch from "algoliasearch";

export default {
    name: "ArticlesOverview",
    props: {
        algoliaAppId: {
            type: String,
            required: true
        },
        indexName: {
            type: String,
            required: true
        },
        algoliaSearchOnlyApiKey: {
            type: String,
            required: true
        },
        employees: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            dislpayType: 'grid',
            searchClient: algoliasearch(
                this.algoliaAppId,
                this.algoliaSearchOnlyApiKey,
            ),
            searchParameters: {
                filters: 'published:true'
            },
        };
    },

    computed: {
        classNamesHits: function() {
            if (this.dislpayType === 'grid') {
                return {
                    'ais-Hits': null,
                    'ais-Hits-list': 'grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
                    'ais-Hits-item': '',
                };
            }
            return {
                'ais-Hits': null,
                'ais-Hits-list': 'flex space-y-4 flex-wrap',
                'ais-Hits-item': 'w-full',
            };

        },
    }
};
</script>

<style scoped>

</style>
